function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _to_primitive(input, hint) {
    if (_type_of(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_type_of(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _to_property_key(arg) {
    var key = _to_primitive(arg, "string");
    return _type_of(key) === "symbol" ? key : String(key);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
import { isType, PartnerAppDataReceivedAction, PowerBIDataReceivedAction, AppsPricingDataReceivedAction, AppDetailPricingReceivedAction, RelatedAppsItemsPricingDataReceivedAction, AppPricingDataReceivedAction, EntityReviewCommentsReceivedAction, EntityReviewCommentsCleanupAction, EntityReviewCommentDeleteResult, EntityReviewCommentUpdateResult, EntityReviewCommentsLoadingAction, EntityReviewCommentsInitializeStateAction, EntityReviewCommentsUpdateTotalCommentCountAction, EntityReviewCommentCreateResult, EntityReviewCommentsUnloadPagesAction, EntityMarkedAsHelpfulReviewUpdateListAction, EntityLinkedInProductGroupUpdateAction, EntityReviewSetIsHelpfulAction, EntityReviewSetMarkAsHelpfulCount, EntityReviewSetIsHelpfulLoadingAction, SetRecommenededSizes, LoadingRecommenededSizes, EntityUserCommentedReviewIdsUpdateListAction, RecommendedWhatsNewAppsReceivedAction, RecommendedTrendingAppsReceivedAction, RecommendedAppsItemsPricingDataReceivedAction, RecommendedMicrosoft365WhatsNewAppsReceivedAction, RecommendedMicrosoft365TrendingAppsReceivedAction } from '@shared/actions/actions';
import { commonEntityDataReducer } from './commonEntityDataReducer';
import { initialAppDataState, copyState, deepCopyDataMap } from './../../State';
import { Constants } from './../utils/constants';
import { loadAppPricing } from './../utils/pricing';
import { parsePBIApps } from '../../embed/reducers/pbiAppDataReducer';
import { parsePartnerApps } from '../../embed/reducers/partnerAppDataReducer';
import { SpzaInstrumentService } from '../services/telemetry/spza/spzaInstrument';
import { generateHashMap } from '../utils/hashMapUtils';
import { updateMatchFunctions } from 'utils/filterHelpers';
import { getFuturePricesInformation } from '@shared/utils/futurePricesUtils';
import { appendReviewCommentsToState, calculateTotalReviewCommentsPagesCount, combineDeletedComments, createInitialReviewCommentsState } from '@shared/utils/reviewsUtils';
import { take, pick, values, map, differenceBy } from 'lodash-es';
import { logger } from '@src/logger';
import { getProductByUrlKey } from '@shared/utils/appUtils';
export default function appDataReducer(state = initialAppDataState, action) {
    const newState = copyState(state);
    const newCommonState = commonEntityDataReducer(Constants.EntityType.App, state, action);
    if (isType(action, AppPricingDataReceivedAction)) {
        var _action_payload_pricingPayload, _action_payload;
        if (!((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : (_action_payload_pricingPayload = _action_payload.pricingPayload) === null || _action_payload_pricingPayload === void 0 ? void 0 : _action_payload_pricingPayload.pricingData)) {
            return state;
        }
        newState.dataList = newState.dataList.map((app)=>{
            var _app_entityId, _action_payload_entityId;
            if (((_app_entityId = app.entityId) === null || _app_entityId === void 0 ? void 0 : _app_entityId.toLowerCase()) === ((_action_payload_entityId = action.payload.entityId) === null || _action_payload_entityId === void 0 ? void 0 : _action_payload_entityId.toLowerCase())) {
                return loadAppPricing(app, action.payload.pricingPayload.pricingData);
            }
            return app;
        });
    } else if (isType(action, RelatedAppsItemsPricingDataReceivedAction)) {
        if (!action.payload.pricingData || Object.keys(action.payload.pricingData).length === 0) {
            return state;
        }
        if (state.relatedAppsItems && state.relatedAppsItems.items) {
            let updatedLinkedAddIns = null;
            let updatedSaasLinkingItems = null;
            let updatedSuggestedItems = null;
            let updatedDataList = null;
            if (state.relatedAppsItems.items.saasLinkingItems) {
                updatedSaasLinkingItems = map(state.relatedAppsItems.items.saasLinkingItems, (app)=>loadAppPricing(app, action.payload.pricingData));
            }
            if (state.relatedAppsItems.items.suggestedItems) {
                updatedSuggestedItems = map(state.relatedAppsItems.items.suggestedItems, (app)=>loadAppPricing(app, action.payload.pricingData));
            }
            if (state.relatedAppsItems.items.linkedAddIns) {
                updatedLinkedAddIns = map(state.relatedAppsItems.items.linkedAddIns, (app)=>loadAppPricing(app, action.payload.pricingData));
                updatedDataList = [
                    ...state.dataList,
                    ...differenceBy(state.relatedAppsItems.items.linkedAddIns, state.dataList, 'entityId')
                ];
            }
            return _object_spread_props(_object_spread({}, state), {
                relatedAppsItems: _object_spread_props(_object_spread({}, state.relatedAppsItems), {
                    items: {
                        linkedAddIns: updatedLinkedAddIns !== null && updatedLinkedAddIns !== void 0 ? updatedLinkedAddIns : state.relatedAppsItems.items.linkedAddIns,
                        suggestedItems: updatedSuggestedItems !== null && updatedSuggestedItems !== void 0 ? updatedSuggestedItems : state.relatedAppsItems.items.suggestedItems,
                        saasLinkingItems: updatedSaasLinkingItems !== null && updatedSaasLinkingItems !== void 0 ? updatedSaasLinkingItems : state.relatedAppsItems.items.saasLinkingItems
                    }
                }),
                dataList: updatedDataList !== null && updatedDataList !== void 0 ? updatedDataList : state.dataList
            });
        }
    } else if (isType(action, RecommendedWhatsNewAppsReceivedAction)) {
        newState.recommendedApps.whatsNewApps = action.payload;
    } else if (isType(action, RecommendedTrendingAppsReceivedAction)) {
        newState.recommendedApps.trendingApps = action.payload;
    } else if (isType(action, RecommendedMicrosoft365WhatsNewAppsReceivedAction)) {
        newState.recommendedApps.microsoft365WhatsNewApps = action.payload;
    } else if (isType(action, RecommendedMicrosoft365TrendingAppsReceivedAction)) {
        newState.recommendedApps.microsoft365TrendingApps = action.payload;
    } else if (isType(action, AppsPricingDataReceivedAction)) {
        const { payload } = action;
        const { pricingData = {} } = payload;
        newState.dataList = state.dataList.map((app)=>loadAppPricing(app, pricingData));
        const dataMap = deepCopyDataMap(state.dataMap);
        updateMatchFunctions(dataMap);
        newState.dataMap = dataMap;
        newState.pricingPayload = payload;
    } else if (isType(action, RecommendedAppsItemsPricingDataReceivedAction)) {
        const { payload } = action;
        const { pricingData = {} } = payload;
        newState.recommendedApps.whatsNewApps = state.recommendedApps.whatsNewApps.map((app)=>loadAppPricing(app, pricingData));
        newState.recommendedApps.trendingApps = state.recommendedApps.trendingApps.map((app)=>loadAppPricing(app, pricingData));
        newState.recommendedApps.microsoft365WhatsNewApps = state.recommendedApps.microsoft365WhatsNewApps.map((app)=>loadAppPricing(app, pricingData));
        newState.recommendedApps.microsoft365TrendingApps = state.recommendedApps.microsoft365TrendingApps.map((app)=>loadAppPricing(app, pricingData));
        newState.pricingPayload = payload;
    } else if (isType(action, PowerBIDataReceivedAction)) {
        if (action.payload.appData) {
            newState.dataList = newState.dataList.concat(parsePBIApps(action.payload.appData));
            newState.idMap = generateHashMap(newState.dataList, [
                'entityId',
                'friendlyURL'
            ]);
            newState.partnerAppDataLoaded = true;
            // This event is used to indicate that the Power BI data is fetched and parsing is done.
            const payload = {
                page: 'In App Gallery(PowerBI)',
                action: Constants.Telemetry.Action.PageLoad,
                actionModifier: Constants.Telemetry.ActionModifier.Info,
                details: '[End] PowerBI data parsing done'
            };
            SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
            logger.info(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier,
                page: payload.page
            });
        }
    } else if (isType(action, PartnerAppDataReceivedAction)) {
        var _getProductByUrlKey;
        if (action.payload.appData) {
            const appData = parsePartnerApps(action.payload.appData, action.payload.embedHost);
            newState.dataList = state.dataList.concat(appData).sort((a, b)=>{
                const aTitle = a.title.toLowerCase();
                const bTitle = b.title.toLowerCase();
                return aTitle > bTitle ? 1 : aTitle < bTitle ? -1 : 0;
            });
            newState.partnerAppDataLoaded = true;
            newState.idMap = generateHashMap(newState.dataList, [
                'entityId'
            ]);
        } else {
            newState.partnerAppDataLoaded = true;
            newState.partnerAppDataLoadedError = true;
        }
        // This event is used to indicate that the Power BI data is fetched and parsing is done.
        const payload = {
            page: 'In App Gallery(' + ((_getProductByUrlKey = getProductByUrlKey({
                urlKey: action.payload.embedHost
            })) === null || _getProductByUrlKey === void 0 ? void 0 : _getProductByUrlKey.UrlKey) + ')',
            action: Constants.Telemetry.Action.PageLoad,
            actionModifier: Constants.Telemetry.ActionModifier.Info,
            details: '[End] Partner App data parsing done'
        };
        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier,
            page: payload.page
        });
    } else if (isType(action, AppDetailPricingReceivedAction)) {
        if (action.payload.pricing) {
            const index = state.idMap[action.payload.entityId.toString().toLowerCase()];
            if (index !== -1) {
                newState.dataList = newState.dataList.slice();
                const currentData = newState.dataList[`${index}`];
                const { futurePrices, pricing } = action.payload;
                newState.dataList[`${index}`] = _object_spread_props(_object_spread({}, currentData), {
                    pricingInformation: action.payload.pricing,
                    futurePricesInformation: getFuturePricesInformation(futurePrices, pricing)
                });
            }
        }
    } else if (isType(action, EntityReviewCommentsReceivedAction)) {
        const { appReviewsData } = newState;
        // Merge data with the previous comment data for the review id
        const { [action.payload.reviewId]: prevReviewCommentsState } = appReviewsData.reviewComments;
        const newReviewCommentsState = _object_spread({}, appendReviewCommentsToState(prevReviewCommentsState, action.payload.comments));
        appReviewsData.reviewComments = _object_spread_props(_object_spread({}, appReviewsData.reviewComments), {
            // Convert the new comment list to normalized data
            [action.payload.reviewId]: _object_spread_props(_object_spread({}, newReviewCommentsState), {
                // Remove newly added comments if they were now loaded into the main list
                newlyAddedComments: newReviewCommentsState.newlyAddedComments.filter((c)=>!newReviewCommentsState.commentsById[c.id]),
                currentLoadedPage: action.payload.pageNumber
            })
        });
    } else if (isType(action, EntityReviewCommentsCleanupAction)) {
        if (newState.appReviewsData.reviewComments && newState.appReviewsData.reviewComments[action.payload.reviewId]) {
            // Clean the comments of the given review from the state
            const _newState_appReviewsData_reviewComments = newState.appReviewsData.reviewComments, _action_payload_reviewId = action.payload.reviewId, { [_action_payload_reviewId]: removedCommentData } = _newState_appReviewsData_reviewComments, newReviewCommentsState = _object_without_properties(_newState_appReviewsData_reviewComments, [
                _action_payload_reviewId
            ].map(_to_property_key));
            newState.appReviewsData.reviewComments = newReviewCommentsState;
        }
    } else if (isType(action, EntityReviewCommentUpdateResult) || isType(action, EntityReviewCommentDeleteResult)) {
        const { payload } = action;
        const { reviewId, isNewlyAddedComment, actionResult } = payload;
        const { [reviewId]: prevReviewCommentsState } = newState.appReviewsData.reviewComments;
        const newReviewCommentsState = _object_spread({}, prevReviewCommentsState);
        if (isNewlyAddedComment) {
            const updatedComment = actionResult.reviewComment;
            newReviewCommentsState.newlyAddedComments = newReviewCommentsState.newlyAddedComments.map((c)=>c.id === updatedComment.id ? updatedComment : c);
        } else {
            // Upon deletion or update of a comment, update it in the state immediately with the returned comment representation
            const commentId = actionResult.reviewComment.id;
            newReviewCommentsState.commentsById = _object_spread_props(_object_spread({}, newReviewCommentsState.commentsById), {
                [commentId]: actionResult.reviewComment
            });
            newReviewCommentsState.reducedCommentIds = combineDeletedComments(newReviewCommentsState);
        }
        // When deleting comments, reduce the comments counter
        if (isType(action, EntityReviewCommentDeleteResult)) {
            const reviewIdx = newState.appReviewsData.reviews.findIndex((r)=>r.id === action.payload.reviewId);
            if (reviewIdx > -1) {
                newState.appReviewsData.reviews[`${reviewIdx}`].comments_count -= 1;
            }
        }
        newState.appReviewsData.reviewComments = _object_spread_props(_object_spread({}, newState.appReviewsData.reviewComments), {
            [reviewId]: newReviewCommentsState
        });
    } else if (isType(action, EntityReviewCommentsLoadingAction)) {
        // Update the loading state for a given review's comments list (ex. when initially expanding the comments section for a review)
        const { [action.payload.reviewId]: prevReviewCommentsState } = newState.appReviewsData.reviewComments;
        // Update the review comments state with the change
        newState.appReviewsData.reviewComments = _object_spread_props(_object_spread({}, newState.appReviewsData.reviewComments), {
            [action.payload.reviewId]: _object_spread_props(_object_spread({}, prevReviewCommentsState), {
                isLoading: action.payload.isLoading
            })
        });
    } else if (isType(action, EntityReviewCommentsUnloadPagesAction)) {
        // Update the current page for a given review's comments list
        const { [action.payload.reviewId]: prevReviewCommentsState } = newState.appReviewsData.reviewComments;
        const { commentIds: prevCommentIds, commentsById: prevCommentsById } = prevReviewCommentsState;
        newState.appReviewsData.reviewComments = _object_spread_props(_object_spread({}, newState.appReviewsData.reviewComments), {
            [action.payload.reviewId]: appendReviewCommentsToState(// Erase loaded data from the comments state
            _object_spread_props(_object_spread({}, prevReviewCommentsState), {
                reducedCommentIds: [],
                commentsById: {},
                commentIds: [],
                currentLoadedPage: 1
            }), // Collect the comments from the first page and add them to the state
            values(pick(prevCommentsById, take(prevCommentIds, Constants.Reviews.CommentsPerPage))))
        });
    } else if (isType(action, EntityReviewCommentsUpdateTotalCommentCountAction)) {
        const { reviewId, totalComments } = action.payload;
        // Update the loading state for a given review's comments list (ex. when initially expanding the comments section for a review)
        const { [reviewId]: reviewCommentsState = createInitialReviewCommentsState() } = newState.appReviewsData.reviewComments;
        // Update the review comments state with the change
        newState.appReviewsData.reviewComments = _object_spread_props(_object_spread({}, newState.appReviewsData.reviewComments), {
            [reviewId]: _object_spread_props(_object_spread({}, reviewCommentsState), {
                totalComments,
                totalPages: calculateTotalReviewCommentsPagesCount(totalComments)
            })
        });
    } else if (isType(action, EntityReviewCommentsInitializeStateAction)) {
        const { [action.payload.reviewId]: newReviewCommentsState = createInitialReviewCommentsState() } = newState.appReviewsData.reviewComments || {};
        newState.appReviewsData.reviewComments = _object_spread_props(_object_spread({}, newState.appReviewsData.reviewComments), {
            [action.payload.reviewId]: _object_spread_props(_object_spread({}, newReviewCommentsState), {
                totalComments: action.payload.totalComments
            })
        });
    } else if (isType(action, EntityReviewCommentCreateResult)) {
        if (!action.payload.actionResult.error) {
            const { [action.payload.reviewId]: prevReviewCommentsState } = newState.appReviewsData.reviewComments;
            let newReviewCommentsState;
            if (action.payload.isNewlyAddedComment) {
                // Add the comment to the newly added comments list
                newReviewCommentsState = _object_spread_props(_object_spread({}, prevReviewCommentsState), {
                    newlyAddedComments: [
                        ...prevReviewCommentsState.newlyAddedComments,
                        action.payload.actionResult.reviewComment
                    ]
                });
            } else {
                // Add the comment to the main list
                newReviewCommentsState = _object_spread({}, appendReviewCommentsToState(prevReviewCommentsState, [
                    action.payload.actionResult.reviewComment
                ]));
            }
            // Inject the new comments state and append the total comments count
            newState.appReviewsData.reviewComments = _object_spread_props(_object_spread({}, newState.appReviewsData.reviewComments), {
                [action.payload.reviewId]: _object_spread_props(_object_spread({}, newReviewCommentsState), {
                    totalComments: prevReviewCommentsState.totalComments + 1
                })
            });
            const reviewIdx = newState.appReviewsData.reviews.findIndex((r)=>r.id === action.payload.reviewId);
            if (reviewIdx > -1) {
                newState.appReviewsData.reviews[`${reviewIdx}`].comments_count += 1;
            }
        }
    } else if (isType(action, EntityMarkedAsHelpfulReviewUpdateListAction)) {
        const { reviewIds } = action.payload;
        newState.appReviewsData.markedAsHelpful.userReviewIdsMarkedAsHelpful = reviewIds;
    } else if (isType(action, EntityLinkedInProductGroupUpdateAction)) {
        const { linkedInProductGroup } = action.payload;
        newState.linkedInProductGroup = linkedInProductGroup;
    } else if (isType(action, EntityReviewSetIsHelpfulAction)) {
        const { reviewId, isHelpful } = action.payload;
        const { markedAsHelpful } = newState.appReviewsData;
        const { userReviewIdsMarkedAsHelpful: prevReviewIds } = markedAsHelpful;
        if (isHelpful) {
            markedAsHelpful.userReviewIdsMarkedAsHelpful = [
                ...prevReviewIds,
                reviewId
            ];
        } else {
            markedAsHelpful.userReviewIdsMarkedAsHelpful = prevReviewIds.filter((r)=>r !== reviewId);
        }
    } else if (isType(action, EntityReviewSetIsHelpfulLoadingAction)) {
        const { isLoading, reviewId } = action.payload;
        const { markedAsHelpful: prevMarkedAsHelpfulState } = newState.appReviewsData;
        const { userReviewIdsLoading: prevLoadingIds } = prevMarkedAsHelpfulState;
        if (isLoading) {
            prevMarkedAsHelpfulState.userReviewIdsLoading = _object_spread_props(_object_spread({}, prevLoadingIds), {
                [reviewId]: true
            });
        } else {
            const _prevMarkedAsHelpfulState_userReviewIdsLoading = prevMarkedAsHelpfulState.userReviewIdsLoading, { [reviewId]: removedListing } = _prevMarkedAsHelpfulState_userReviewIdsLoading, newUserReviewIdsLoading = _object_without_properties(_prevMarkedAsHelpfulState_userReviewIdsLoading, [
                reviewId
            ].map(_to_property_key));
            prevMarkedAsHelpfulState.userReviewIdsLoading = newUserReviewIdsLoading;
        }
    } else if (isType(action, EntityReviewSetMarkAsHelpfulCount)) {
        const { reviewId, count } = action.payload;
        const { reviews } = newState.appReviewsData;
        const reviewIdx = reviews.findIndex((r)=>r.id === reviewId);
        if (reviewIdx > -1) {
            reviews[`${reviewIdx}`].mark_as_helpful_count = count;
        }
    } else if (isType(action, LoadingRecommenededSizes)) {
        const { entityId, planId } = action.payload;
        newState.recommendedSizesState = {
            entityId,
            planId,
            loading: true,
            recommendedSizes: []
        };
    } else if (isType(action, SetRecommenededSizes)) {
        const { entityId, planId, recommendedSizes } = action.payload;
        newState.recommendedSizesState = {
            entityId,
            planId,
            loading: false,
            recommendedSizes
        };
    } else if (isType(action, EntityUserCommentedReviewIdsUpdateListAction)) {
        const { commentReviewIds } = action.payload;
        newState.appReviewsData.userCommentedReviewIds = commentReviewIds;
    } else {
        return newCommonState;
    }
    return newState;
}
